import { render, staticRenderFns } from "./EditSPTPage.vue?vue&type=template&id=1da648d5&scoped=true&"
import script from "./EditSPTPage.vue?vue&type=script&lang=js&"
export * from "./EditSPTPage.vue?vue&type=script&lang=js&"
import style0 from "./EditSPTPage.vue?vue&type=style&index=0&id=1da648d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da648d5",
  null
  
)

export default component.exports